'use client';

import SwrLocalCacheProvider from '@/lib/swr/SwrLocalCacheProvider';

export default function PredicLayoutClient({ children }: { children: React.ReactNode }) {
  // 为 predic 子树的全部 GET 请求提供 localStorage 缓存与失败回退；
  // 注意 openDrawer 等渲染在根布局的内容不在此子树内，需各自包裹 Provider
  return <SwrLocalCacheProvider>{children}</SwrLocalCacheProvider>;
}
